const getCookieLang = (cookie = document.cookie) => {
  if (cookie) {
    const data = cookie.split(';').map((e) => e.trim().split('='))
    const cookieData: any = data.reduce((acc, e) => {
      acc[e[0]] = e[1]
      return acc
    }, {})
    return cookieData.lang || cookieData.ulocale
  }
}

const getEnvLang = (langList = ['zh-CN'], defaultLang = 'zh-CN') => {
  let lang = defaultLang

  // 浏览器 lang
  if (navigator && navigator.language) {
    lang = navigator.language
  }

  // cookie lang
  const cookieLang = getCookieLang()
  if (cookieLang) {
    lang = cookieLang
  }

  // url lang
  const urlLangs = /lang=([\w-]+)/.exec(location.search)
  if (urlLangs && urlLangs.length && urlLangs.length === 2) {
    lang = urlLangs[1] || defaultLang
  }

  // 匹配xx-XX-xx，xx-XX或xx，不匹配返回默认语言
  if (Array.isArray(langList) && langList.length) {
    // 配置前缀的语言列表
    const matchPrefixList = langList.filter(
      (l) => l.indexOf(lang.split('-')[0]) === 0
    )
    // 全匹配 =》 配置前缀第一个 =》 默认语言
    return (
      matchPrefixList.find((l) => l === lang) ||
      matchPrefixList[0] ||
      defaultLang
    )
  }

  return lang
}

export default getEnvLang
